<template>
  <v-form id="employeeDetails" ref="form" lazy-validation>
    <PhoneAnswering v-if="isPhoneAnsweringAvailable" ></PhoneAnswering>
    <MailHandling v-if="isMailHandlingAvailable"></MailHandling>
    <p>{{$t('employee_details.text')}} <strong>{{$t('employee_details.subtext')}}</strong></p>
    <v-divider class="pb-2" ></v-divider>
    <div v-for="(employee, index) in employees" :key="index">
      <strong>Additional Employee: {{index + 1}}</strong>
      <v-row class="mb-n4">
        <v-col>
          <v-text-field required solo dense
              :placeholder="$t('employee_details.employee.first_name.placeholder')"
              :value="employee.first_name"
              :rules="employee.requires_validation? rules.first_name : []"
              @change="commitEmployeeFirstNameUpdate($event, index)"
              maxlength="25"
              counter
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field required solo dense
              :placeholder="$t('employee_details.employee.last_name.placeholder')"
              :value="employee.last_name"
              :rules="employee.requires_validation ? rules.last_name : []"
              @change="commitEmployeeLastNameUpdate($event, index)"
              maxlength="25"
              counter
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="mb-n4">
        <v-col>
          <v-text-field required solo dense
              :placeholder="$t('employee_details.employee.email.placeholder')"
              :rules="employee.requires_validation? rules.email : []"
              :value="employee.email"
              @change="commitEmployeeEmailUpdate($event, index)"
              maxlength="50"
              counter
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field required solo dense
              :placeholder="$t('employee_details.employee.phone.placeholder')"
              :rules="employee.requires_validation? rules.phone : []"
              :value="employee.phone"
              v-mask="['##########']"
              @change="commitEmployeePhoneUpdate($event, index)"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-divider class="mb-2"></v-divider>
    </div>
    <v-row>
      <v-col>
        <v-btn small text class="float-left" :disabled="employees.length <= 1" @click="removeEmployee">Remove last employee</v-btn>
      </v-col>
      <v-col>
        <v-btn small text class="float-right" @click="addEmployee">Add another employee</v-btn>
      </v-col>
    </v-row>
    <ServiceOptions></ServiceOptions>
    <v-row>
      <v-col>
        <v-btn @click="goBack">Go back</v-btn>
      </v-col>
      <v-col>
        <v-btn @click="validate" class="float-right">Continue</v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
  import {mapState, mapActions} from "vuex";
  import PhoneAnswering from './PhoneAnswering';
  import MailHandling from './MailHandling';
  import ServiceOptions from './ServiceOptions';

  export default {
    name: 'EmployeeDetails',
    components: {
      PhoneAnswering,
      MailHandling,
      ServiceOptions,
    },
    data: function () {
      return {
        rules: {
          first_name: [
            v => !!v || this.$t('employee_details.employee.first_name.required'),
            ],
          last_name: [
            v => !!v || this.$t('employee_details.employee.last_name.required'),
            ],
          email: [
            v => !!v || this.$t('employee_details.employee.email.required'),
            v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$t('employee_details.employee.email.invalid'),
          ],
          phone: [
            v => !!v || this.$t('employee_details.employee.phone.required'),
          ],
        },
      }
    },
    computed: {
      ...mapState('employee_details', [
        'employees',
      ]),
      ...mapState('service_data', {
        isPhoneAnsweringAvailable: state => state.selected.public_plan_variables.has_answering_service ? JSON.parse(state.selected.public_plan_variables.has_answering_service) : false,
        isMailHandlingAvailable: state => state.selected.public_plan_variables.has_mail_handling ? JSON.parse(state.selected.public_plan_variables.has_mail_handling) : false,
        isAddressAvailable: state => state.selected.public_plan_variables.address_available ? JSON.parse(state.selected.public_plan_variables.address_available) : false,
        isEmployeeFormAvailabel: state => state.selected.public_plan_variables.show_employee_form ? JSON.parse(state.selected.public_plan_variables.show_employee_form) : false,
      }),
    },
    methods: {
      ...mapActions('employee_details', [
        'addEmployee',
        'removeEmployee',
      ]),
      validate() {
        console.log(this.$refs.form.validate());
        this.$store.dispatch('service_data/stageSubmission', this.$refs.form).then( next => {
          console.log(next);
          console.log("Moving to next page");
          this.$router.push(next);
        }).catch(err => {
          console.log(err);
        });
      },
      goBack() {
        this.$store.dispatch('service_data/goBack').then((next) => {
          this.$router.push(next);
        });
      },
      commitEmployeeFirstNameUpdate(value, index) {
        this.$store.commit('employee_details/updateFirstName', {value, index});
      },
      commitEmployeeLastNameUpdate(value, index) {
        this.$store.commit('employee_details/updateLastName', {value, index});
      },
      commitEmployeeEmailUpdate(value, index) {
        this.$store.commit('employee_details/updateEmail', {value, index});
      },
      commitEmployeePhoneUpdate(value, index) {
        this.$store.commit('employee_details/updatePhone', {value, index});
        this.$store.dispatch('employee_details/validatePhoneNumber', index);
      },
    },
    created() {
      const payload = {
        title: this.$t('employee_details.sidebar.title'),
        subtext: this.$t('employee_details.sidebar.subtext', { plan: this.$store.getters["service_data/plan_name"] }),
      };
      this.$store.commit('service_data/setSidebarText', payload);
    },
  }
</script>
<style scoped>
  form h2 {
    font-size: 29px;
    letter-spacing: -1px;
    font-weight: 400;
  }
  form p {
    margin-bottom: 0;
  }
  form v-divider {
    padding-bottom: 10px;
  }

</style>
